// UC14 Phase 5.3: module Vuex rieng cho step-up OTP (KHONG gop vao common - tach biet login OTP cu).
import actions from "./actions";

export default {
  namespaced: true,
  actions,
};
